import { Form } from "./Form";
import { ensureElement } from "../../../utils/utils";
export class FormOrder extends Form {
    constructor(container, events) {
        super(container, events);
        this._cardButton = ensureElement('button[name="card"]', this.container);
        this._cashButton = ensureElement('button[name="cash"]', this.container);
        this._cardButton.addEventListener('click', () => this.setPayment('card'));
        this._cashButton.addEventListener('click', () => this.setPayment('cash'));
    }
    setPayment(method) {
        if (method === 'card') {
            this._cardButton.classList.add('button_alt-active');
            this._cashButton.classList.remove('button_alt-active');
        }
        else {
            this._cashButton.classList.add('button_alt-active');
            this._cardButton.classList.remove('button_alt-active');
        }
        this.onInputChange('payment', method);
    }
    set address(value) {
        this.container.elements.namedItem('address').value = value;
    }
    disableButtons() {
        this._cardButton.classList.remove('button_alt-active');
        this._cashButton.classList.remove('button_alt-active');
    }
}
